export default {
      id: "pushpay-logo-grey-usage",
      viewBox: "0 0 1200 335.8",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pushpay-logo-grey",
      toString: function () {
        return this.url;
      }
    }